import { NavLink } from "react-router-dom";
import { LayoutDashboard, Users, UserPlus, Sparkles, Settings } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * Mobile-only fixed bottom navigation. Hidden on tablet+ (sm:hidden).
 * Adds safe-area-inset-bottom padding for iPhone home indicator.
 */
export const BottomNav = () => {
  const { t } = useTranslation();
  const tabs = [
    { to: "/dashboard", icon: LayoutDashboard, label: t("nav.dashboard"), testId: "bnav-dashboard" },
    { to: "/groups", icon: Users, label: t("nav.groups"), testId: "bnav-groups" },
    { to: "/friends", icon: UserPlus, label: t("nav.friends"), testId: "bnav-friends" },
    { to: "/pro-dashboard", icon: Sparkles, label: t("nav.pro_dashboard"), testId: "bnav-pro" },
    { to: "/settings", icon: Settings, label: t("nav.settings"), testId: "bnav-settings" },
  ];

  return (
    <nav
      className="sm:hidden fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-background/95 backdrop-blur-xl"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="bottom-nav"
    >
      <div className="grid grid-cols-5 h-16">
        {tabs.map(({ to, icon: Icon, label, testId }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={testId}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 transition ${
                isActive ? "text-[#00d4ff]" : "text-muted-foreground hover:text-foreground"
              }`
            }
          >
            <Icon className="h-5 w-5" strokeWidth={1.75} />
            <span className="text-[10px] font-mono uppercase tracking-wider leading-none truncate max-w-full px-1">
              {label}
            </span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
